import isEmpty from 'lodash/isEmpty'
import { sub, add } from '@/utils/accurateNumber'
import { mapState, mapGetters } from 'vuex'
import { amountFormat } from '@page_detail/components/Coupon/new/utils'
export default {
  computed: {
    ...mapGetters([
      'isLogin',
      'isRuPubgm',
      'isAllExternalGames',
      'isParallelRequestsGame',
    ]),
    ...mapState(['gameName', 'pubgmDiscount', 'isMobile']), //!!!  <pubgmDiscount>  针对pubgm的价格折扣、未登录【原神也有、模板化记得注意】
    ...mapState('detail', [
      'selectSkuItem',
      'selectChannelItem',
      'couponDiscountMoney',
    ]),

    // warn 【外部】SKU的价格 [官方价格] 显示的是含税价格哦~ 需要单独处理[
    //warn ： ~ 展示用
    hackOriginalPrice() {
      if (isEmpty(this.selectSkuItem)) return 0
      if (this.isAllExternalGames || this.isParallelRequestsGame) {
        return this.selectSkuItem.skuPrice || 0
      }
      return this.selectSkuItem.originalPrice || 0
    },

    // ! SKU的价格 [官方价格]\真正计算不管外部、还是内部都是从字段计算的
    originalPrice() {
      if (isEmpty(this.selectSkuItem)) return 0
      if (this.isAllExternalGames) {
        return this.selectSkuItem.skuPrice || 0
      }
      return this.selectSkuItem.originalPrice || 0
    },

    // 支付通道的价格[实际支付价格]
    channelPrice() {
      if (isEmpty(this.selectChannelItem)) return 0
      return this.selectChannelItem.channelPrice || 0
    },

    // 支付通道的优惠
    payChannelprice() {
      if (this.originalPrice == 0) return 0
      if (this.originalPrice < this.channelPrice) return 0

      const _originDiscountPrice = sub(this.originalPrice, this.channelPrice)
      // const _finalPrice = mul(this.channelPrice, this.pubgmDiscount)
      // const _ruPubgmDiscountPrice = sub(
      //   this.originalPrice,
      //   Math.ceil(_finalPrice)
      // )
      // return this.isRuPubgm
      //   ? Number(amountFormat(_ruPubgmDiscountPrice))
      //   : Number(amountFormat(_originDiscountPrice))

      return Number(amountFormat(_originDiscountPrice))
    },

    // 折扣金额【M站显示】
    // 优惠券 + 支付通道价格
    discountPrice() {
      return add(this.payChannelprice, this.couponDiscountMoney)
    },

    // 最终价格【需要支付的价格】
    finalPrice() {
      let price = 0

      // 如果没有配置支付通道的时候、那么默认就是0
      if (this.channelPrice === 0) {
        price = 0
      } else if (this.isLogin) {
        price = sub(this.channelPrice, this.couponDiscountMoney)
      } else {
        price = this.channelPrice
      }
      return price
    },

    // 是否渲染[划线价格]
    isRenderScribingPrice() {
      const { originalPrice = 0, skuId: oID } = this.selectSkuItem
      const { channelPrice = 0, skuId: cID } = this.selectChannelItem

      if (oID !== cID) return false
      if (originalPrice === 0 || channelPrice === 0) return false
      if (
        Number(originalPrice) <= Number(channelPrice) &&
        Number(this.finalPrice) === Number(originalPrice)
      ) {
        return false
      }

      // warn：当前实际支付的价格不能未负数。
      // 边界情况：优惠券的配置金额大于实际支付的价格
      if (this.finalPrice < 0) return false
      return true
    },

    submitText() {
      const hackGames = ['soul-land3d', 'genshin-en', 'shining-nikki']
      let subText = ''

      if (hackGames.includes(this.gameName)) {
        subText = this.$t(`${this.gameName}.submit_btn_text`)
      } else {
        subText = this.$t('order.continue_to_pay')
      }

      return subText
    },

    // warn 针对某些CP 未登录显示一些折扣之类的
    // 实际支付的价格还是【finalPrice】
    hackFinalPrice() {
      // if (this.isRuPubgm) {
      //   const pubgmPrice = mul(this.finalPrice, this.pubgmDiscount)
      //   return Math.ceil(pubgmPrice)
      // }
      return this.finalPrice
    },
  },
}
